import { events } from '../Notifications/reducers/trackerNotifications';

const permissions = {
  videoDashboard: 'VD001',
  eventsHistory: 'VD002',
  videoHistory: 'VD003'
};

export default permissions;
